var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('v-row',[_c('span',[_c('ImplicitActivitiesDialog',{attrs:{"implicit-activity":_vm.implicitActivity,"explicit-name":_vm.explicitActivity.name},on:{"update":_vm.save}})],1)]):_c('v-row',[_c('DataLoader',{attrs:{"custom-loading-trigger":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }